import Vue from 'vue';
import store from '@/store';

Vue.filter('translate', (key) => store.getters.translations[key] || key);
